import { Component } from '@angular/core';

import {ModalComponent} from "../../../utils/modal/modal.component";
import {FormGroup} from "@angular/forms";
import {MdbModalRef} from "mdb-angular-ui-kit/modal";
import {HttpErrorsService} from "../../../../services/utils/http-errors.service";
import {finalize} from "rxjs";
import {EmployeeService} from "../../../../services/resources/employee.service";
import {EmployeeModel} from "../../../../models/resources/employee.model";
import {EmployeeFormComponent} from "../../../forms/employee-form/employee-form.component";

@Component({
  selector: 'app-new-employee-modal',
  imports: [
    EmployeeFormComponent,
    ModalComponent,
  ],
  templateUrl: './new-employee-modal.component.html',
  styleUrl: './new-employee-modal.component.scss',
})
export class NewEmployeeModalComponent {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    private modalRef: MdbModalRef<NewEmployeeModalComponent>,
    private httpErrorService: HttpErrorsService,
    private employeeService: EmployeeService
  ) {}

  submit() {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid)
      return;

    this.loading = true;

    let resource = this.formGroup!.value;

    this.employeeService
      .create(resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (employee: EmployeeModel) => {
          this.modalRef.close(employee);
        },
        error: (e) => {
          this.httpErrorService.handleError(e);
        },
      });
  }

  getValueOf(controlName: string) {
    return this.formGroup?.get(controlName)?.value;
  }
}
